export default "__VITE_ASSET__wXF5WyWQ__"